// 漫畫 一行兩個
import { CmsGridWrapper } from 'commonStyledComponents'
import NovelBox from 'component/NovelBox'
import { memo } from 'react'

interface Template301Props {
  videoData?: any[]
  trigger?: React.ReactNode
  currentLimit?: number
}

/**
 * 模板 ID: "301": 豎版一行兩個
 * */
function Template301({ videoData, trigger, currentLimit }: Template301Props) {
  return (
    <CmsGridWrapper>
      {videoData?.slice(0, currentLimit).map((item, i) => {
        return <NovelBox overflow={true} columns={2} key={i} novelInfo={item} allowUnload />
      })}
      {trigger}
    </CmsGridWrapper>
  )
}

// this indicate areaBox should hide bottom section until fully shown
;(Template301 as any).lazy = true
export default memo(Template301)
